import { useId, useMemo, useState } from 'react';
import { MdExpandLess, MdExpandMore } from 'react-icons/md';

const GROUPS = [
    { label: 'Документы', extensions: ['PDF', 'DOC', 'DOCX', 'RTF', 'TXT', 'ODF', 'ODT', 'XODT', 'SXW', 'MSG'] },
    { label: 'Таблицы', extensions: ['XLS', 'XLSX', 'CSV', 'ODS', 'SXC'] },
    { label: 'Изображения', extensions: ['JPG', 'JPEG', 'BMP', 'TIF', 'TIFF', 'GIF', 'PNG', 'SVG', 'WEBP'] },
    { label: 'Архивы', extensions: ['ZIP', '7Z', 'RAR', 'ARJ'] },
    { label: 'Презентации', extensions: ['ODP', 'PPT', 'PPTX'] },
    { label: 'Чертежи', extensions: ['DWG', 'DXF'] },
];

const labelOf = (token: string) => {
    if (token === 'image/*') return 'Изображения';
    if (token === 'audio/*') return 'Аудио';
    if (token === 'video/*') return 'Видео';
    return token.includes('/') ? token : token.replace(/^\./, '').toUpperCase();
};

export default function AcceptedFileFormats({ accept }: { accept: string }) {
    const [opened, setOpened] = useState(false);
    const id = useId();
    const formats = useMemo(() => {
        const tokens = accept
            .split(',')
            .map((s) => s.trim().toLowerCase())
            .filter(Boolean);
        if (tokens.some((t) => t === '*' || t === '*/*')) return [];
        return [...new Set(tokens.map(labelOf))];
    }, [accept]);
    const preview = [...['PDF', 'DOCX', 'XLSX', 'ZIP'].filter((f) => formats.includes(f)), ...formats];
    const summary = [...new Set(preview)].slice(0, 4);
    const known = new Set(GROUPS.flatMap((g) => g.extensions));
    const groups = [
        ...GROUPS.map((g) => ({ label: g.label, extensions: formats.filter((f) => g.extensions.includes(f)) })),
        { label: 'Другие форматы', extensions: formats.filter((f) => !known.has(f)) },
    ].filter((g) => g.extensions.length > 0);

    if (!formats.length) return null;

    return (
        <div className="rf-file-input__formats">
            <div className="rf-file-input__formats-summary">
                <span>{summary.join(', ')}</span>
                {formats.length > summary.length && (
                    <button
                        type="button"
                        aria-expanded={opened}
                        aria-controls={id}
                        onClick={(event) => {
                            event.stopPropagation();
                            setOpened(!opened);
                        }}
                    >
                        и ещё {formats.length - summary.length}
                        {opened ? <MdExpandLess aria-hidden /> : <MdExpandMore aria-hidden />}
                    </button>
                )}
            </div>
            {opened && formats.length > summary.length && (
                <div className="rf-file-input__formats-panel" id={id}>
                    <span className="rf-file-input__formats-title">Допустимые форматы ({formats.length})</span>
                    <div className="rf-file-input__formats-groups">
                        {groups.map((g) => (
                            <div className="rf-file-input__formats-group" key={g.label}>
                                <span className="rf-file-input__formats-label">{g.label}</span>
                                <div className="rf-file-input__formats-values">
                                    {g.extensions.map((f) => (
                                        <span key={f}>{f}</span>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}
